import { Empty, type EmptyProps } from "antd";
import { memo } from "react";

export interface CustomEmptyProps extends EmptyProps {}

function CustomEmpty({ ...rest }: CustomEmptyProps) {
  return <Empty {...rest} />;
}

export default memo(CustomEmpty);
